export const UA_CHECKBOX = 'ua-checkbox';
